import {IPreAuthDataForm} from "../../models/models";

export const PRE_AUTH_FORM_INITIAL_VALUE: IPreAuthDataForm = {
	billingAcriss: '',
	paymentTiming: '',
	segment: '',
	category: '',
	product: '',
	surchargeUpsell: '',
	bookedRentalAmount: '',
	bookedAncillaries: '',
	bookedTotalAmount: '',
	first: {
		preAuthChoice: "SUGGESTED",
		suggestedPreAuthValue: '',
		alternativePreAuthValue: '',
	},
	second: {
		preAuthChoice: "SUGGESTED",
		suggestedPreAuthValue: '',
		alternativePreAuthValue: '',
	}
}


/**
 NO_OPERATION - no operation performed,
 OK - ok,
 KO - ko,
 OK_TO_BE_RECONCILED - ok after upload the check,
 CANCELLED - cancelled,
 NOT_EXPECTED - esito non atteso
 */
export enum verifyPossibleStatusValue {
	noOperation = 'NO_OPERATION',
	ok = 'OK',
	ko = 'KO',
	okToBeReconciled = 'OK_TO_BE_RECONCILED',
	cancelled = 'CANCELLED',
	notExpected = 'NOT_EXPECTED'
}